module.exports = __webpack_public_path__ + "static/media/ex-award.02fcf446.png";